import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { routes } from './routes'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ToastContainer, Zoom } from 'react-toastify'
import { AuthProvider } from 'context/authContext'
import 'styles/globals.scss'
import { Provider } from 'react-redux'
import { persistor, store } from 'store/redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { PostHogProvider } from 'posthog-js/react'
import { PersistGate } from 'redux-persist/integration/react'
const options = {
    api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
}
const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            retry: false,
        },
        queries: {
            refetchOnWindowFocus: true,
            retry: false,
        },
    },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <PostHogProvider
                    apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
                    options={options}
                >
                    <QueryClientProvider client={queryClient}>
                        <AuthProvider>
                            <RouterProvider router={routes} />
                            <ToastContainer
                                position="top-center"
                                className="text-right"
                                transition={Zoom}
                                hideProgressBar={true}
                            />
                        </AuthProvider>
                    </QueryClientProvider>
                </PostHogProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
)
serviceWorkerRegistration.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
//fucking test
//fucking test 2
